import { useMemo, useState } from "react";
import Card from "./Card.jsx";
import Ball from "../Ball.jsx";
import { simulatePrev } from "../../lib/lotto.js";

const PRIZE = ["꽝", "꽝", "꽝", "5등", "4등", "3등", "1등"];

export default function Verifier({ rows }) {
  const [text, setText] = useState("3,11,17,22,32,41");
  const picked = useMemo(() => {
    const nums = text.split(/[,\s]+/).map(Number).filter((n) => n >= 1 && n <= 45);
    return [...new Set(nums)].slice(0, 6);
  }, [text]);

  const valid = picked.length === 6;
  const sim = useMemo(
    () => (valid ? simulatePrev(rows, picked) : null),
    [rows, picked, valid]
  );

  return (
    <Card title="번호 검증" subtitle="입력한 6개 번호를 과거 모든 회차와 매칭" span={2}>
      <div className="controls">
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={{ width: 220 }}
          placeholder="3,11,17,22,32,41"
        />
        <div className="row" style={{ gap: 4 }}>
          {picked.map((n) => (
            <Ball key={n} n={n} />
          ))}
          {!valid && (
            <span className="muted">1~45 사이 6개 번호를 콤마로 입력</span>
          )}
        </div>
      </div>
      {valid && sim && (
        <div className="grid-2" style={{ marginTop: 10 }}>
          <div>
            <h4 className="muted">매칭 횟수</h4>
            {sim.counts.map((c, k) => (
              <div key={k} className="row">
                <span style={{ width: 110 }}>
                  {k}개 일치 <span className="muted">({PRIZE[k]})</span>
                </span>
                <strong style={{ color: k >= 3 ? "#d33" : "inherit" }}>
                  {c}
                </strong>
              </div>
            ))}
          </div>
          <div>
            <h4 className="muted">최근 4등 (4개 일치)</h4>
            <p>
              {sim.recentFour > 0
                ? `${sim.recentFour}회 전`
                : "최근 회차 내 매칭 없음"}
            </p>
          </div>
        </div>
      )}
    </Card>
  );
}
